import { IUpdateAvaliacaoHabilidadeUseCase } from "../../../presentation/useCases/update/update_avaliacao_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateAvaliacaoHabilidadeUseCase
 */

export class UpdateAvaliacaoHabilidadeUseCase implements IUpdateAvaliacaoHabilidadeUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateAvaliacaoHabilidade(
    idAvaliacaoHabilidade: number,
    descricao: string,
    data: Date,
    idAvaliadoPor: number,
    dataReavaliacao: Date | null,
    observacao: string,
    habilidadeItems: {
      idHabilidadeItem: number;
      idHabilidade: number;
      habilidade: string | null;
      notaSelecionada: number | null;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.repository.updateAvaliacaoHabilidade(
      idAvaliacaoHabilidade,
      descricao,
      data,
      idAvaliadoPor,
      dataReavaliacao,
      observacao,
      habilidadeItems.map((x) => ({
        idAvaliacaoHabilidadeItem: x.idHabilidadeItem,
        nota: x.notaSelecionada,
      })),
    );
  }
}